<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  import productsData from '@/data/products.json'

  export default {
    name: 'Products',

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        // 'background-info',
        'products-gallery',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'products',
      },
    },

    data: () => ({
      // 动态分类标题，由 ProductsGallery 通过 $root 事件更新
      dynamicCategoryTitle: '',
    }),

    metaInfo() {
      const title = this.dynamicCategoryTitle || this.$t('products.title')
      const description = this.$t('products.subtitle')
      const origin = typeof window !== 'undefined' ? window.location.origin : ''
      const items = (productsData?.products || []).map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.title,
        url: `${origin}/${this.$i18n.locale}/products/${item.slug || item.id}`,
        image: item.imgUrl,
      }))
      return {
        title,
        meta: [
          { vmid: 'description', name: 'description', content: description },
        ],
        script: [
          {
            vmid: 'products-jsonld',
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              name: title,
              itemListElement: items,
            },
          },
        ],
      }
    },

    mounted() {
      // 监听 ProductsGallery 广播的 tab 切换事件，同步更新浏览器 <title>
      this._productsTabHandler = ({ label, isAll }) => {
        this.dynamicCategoryTitle = isAll ? '' : label
      }
      this.$root.$on('gallery-tab-changed', this._productsTabHandler)
    },

    beforeDestroy() {
      if (this._productsTabHandler) {
        this.$root.$off('gallery-tab-changed', this._productsTabHandler)
      }
    },
  }
</script>
